import { history } from '../../helpers';

import type { QuestionnaireHistoryParams } from './types';

export function redirectToDashboardOnClientError(code: string | undefined) {
  const status = Number(code);
  if (status >= 400 && status < 500) {
    history.navigate('/dashboard');
  }
}

export function buildQuestionnaireHistoryUrl(
  baseUrl: string,
  params: QuestionnaireHistoryParams,
): string {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  const queryString = searchParams.toString();
  return `${baseUrl}${queryString ? `?${queryString}` : ''}`;
}

export function decrementPendingGeneralInfoUpdates(state: {
  pendingGeneralInfoUpdateCount: number;
  updateGeneralInfoLoading: boolean;
}) {
  state.pendingGeneralInfoUpdateCount = Math.max(state.pendingGeneralInfoUpdateCount - 1, 0);
  state.updateGeneralInfoLoading = state.pendingGeneralInfoUpdateCount > 0;
}
